import { useEffect, useRef, useState } from "react";
import { Form } from "react-bootstrap";
import Spinner from 'react-bootstrap/Spinner';
import { withTranslation } from "react-i18next";
import { BiChevronRight } from "react-icons/bi";
import { Link, useNavigate, useParams } from "react-router-dom";
import HTMLEditor from "../../../components/Editor/HTMLEditor";
import OfficePageService from '../../../core/service/OfficePageService';
import { OfficePageType } from "../../../core/constants/common";

const OfficePageEditor = ({ t }) => {
	const navigate = useNavigate();
	const { type } = useParams();
	const [validated, setValidated] = useState(false);
	const [formData, setFormData] = useState({
		name: '',
		content: '',
		type: type
	});	
	const [saveEnabled, setSaveEnabled] = useState(false);
	const [saveInProgress, setSaveInProgress] = useState(false);
	const editorRef = useRef(null);

	useEffect(() => {
		OfficePageService.getActivePage(type).then(res => {
			if (res.status !== 200) return;

			setFormData({
				name: res.data?.name ?? '',
				content: res.data?.content ?? '',
				type: type
			});
		}).catch(error => {
		});
	}, []);

	const onSave = () => {
		setValidated(true);
		if (!formData.name) {
			return;
		}
		setSaveInProgress(true);
		let htmlContent = editorRef?.current?.getContent();
		htmlContent = htmlContent.replace(/>\s+</g, '><');
		const dataToSave = { 
			...formData,
			content: htmlContent
		};
		OfficePageService.addPage(dataToSave).then((response) => {
			if (response.status !== 201 && response.status !== 200) return;

			setSaveInProgress(false);
			navigateToHome();
		}).catch((error) => {
			setSaveInProgress(false);
		});
	};

	const navigateToHome = () => {
		if (type == OfficePageType.TERMS_OF_USE) {
			navigate('../terms');
		} else if (type == OfficePageType.PRIVACY_NOTICE) {
			navigate('../privacy_notice');
		} else if (type == OfficePageType.GDPR_STATEMENT) {
			navigate('../gdpr');
		}	
	};

	return (
		<>
			<section>
				<div className="Main_body">
					<div className="Company_formBox col-lg-12">
						<div className="List_header">
							<h5 className="MH">
								<Link to="#" onClick={() => navigateToHome()}									
									className="Search_iocnBox">
									{
										type == OfficePageType.TERMS_OF_USE ? t("TermsOfUse.label")
											: type == OfficePageType.PRIVACY_NOTICE ? t("PrivacyNotice.label")
												: type == OfficePageType.GDPR_STATEMENT ? t("GDPRStatement.label")
													: ''
									}
								</Link>								
							</h5>
						</div>

						<Form noValidate validated={validated}>
							<div className="mb-4 row mx-0">
								<div className="col-lg-12 p-2">
									<label className="mb-1">
										{t("Name.label")} *
									</label>
									<input
										required
										type="text"
										className="form-control"
										value={formData.name}
										onChange={(e) => setFormData({ ...formData, name: e.target.value })} />
								</div>
								<div>
									<HTMLEditor editorRef={editorRef}
										initialValue={formData.content}
										plugins={['lists', 'pagebreak', 'link', 'code']}
										toolbar={
											'undo redo | formatselect | ' +
											'bold italic forecolor backcolor fontsize fontfamily | alignleft aligncenter ' +
											'alignright alignjustify | link bullist numlist outdent indent pagebreak removeformat | code'
										}
										onContentChange={(e) => {
											setSaveEnabled(true);
										}} />
								</div>
							</div>
							<div className="text-center">
								<button
									type="submit"
									className="btn btn-secondary me-2"
									onClick={() => navigateToHome()}>
									{t("Cancel.label")}
								</button>
								<button type="button" 
									className="btn  btn-primary px-4 sbmBtn"
									disabled={!saveEnabled || saveInProgress} 
									onClick={() => onSave()}>
									{
										saveInProgress
										?
										<Spinner
											as="span"
											animation="border"
											size="sm"
											role="status"
											aria-hidden="true"
										/>
										: <>{t("Save.label")}</>
									}
								</button>
							</div>
						</Form>
					</div>
				</div>
			</section>
		</>
	);
}

export default withTranslation()(OfficePageEditor);